import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThermostatSetupSuccessComponent } from '@app/modules/smart-devices/components/thermostat-setup-success/thermostat-setup-success.component';
import { HasSmartAccountsGuard } from '@app/modules/smart-devices/guards/has-smart-accounts.guard';
import { HasSmartDevicesWritePermissionGuard } from '@app/modules/smart-devices/guards/has-smart-devices-write-permission.guard';
import { DeviceSettingsComponent } from '@app/modules/smart-devices/pages/device-settings/device-settings.component';
import { DeviceSetupSuccessComponent } from '@app/modules/smart-devices/pages/device-setup-success/device-setup-success.component';
import { ThermostatSetupSuccessDoneComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-done/thermostat-setup-success-done.component';
import { ThermostatSetupSuccessLongTermComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-long-term/thermostat-setup-success-long-term.component';
import { ThermostatSetupSuccessOccupiedComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-occupied/thermostat-setup-success-occupied.component';
import { ThermostatSetupSuccessPresetsComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-presets/thermostat-setup-success-presets.component';
import { ThermostatSetupSuccessUnoccupiedComponent } from '@app/modules/smart-devices/pages/thermostat-setup-success-unoccupied/thermostat-setup-success-unoccupied.component';
import { HasEntitlementForFeatureGuard } from '@app/shared/guards/has-entitlement-for-feature.guard';
import { EntitlementEnum } from '@app/shared/interfaces';
import { DeviceDashboardComponent } from './pages/device-dashboard/device-dashboard.component';
import { DeviceSetupComponent } from './pages/device-setup/device-setup.component';
import { DeviceThermostatPresetDetailComponent } from './pages/device-thermostat-preset-detail/device-thermostat-preset-detail.component';
import { DeviceThermostatPresetsComponent } from './pages/device-thermostat-presets/device-thermostat-presets.component';

const routes: Routes = [
  {
    path: '',
    component: DeviceDashboardComponent,
    data: {
      title: 'Device Dashboard',
      feature: EntitlementEnum.SmartDevices,
      redirectPath: '/demo/devices',
    },
    canActivate: [HasEntitlementForFeatureGuard, HasSmartAccountsGuard],
  },
  {
    path: 'setup',
    component: DeviceSetupComponent,
    data: {
      title: 'Device Setup',
    },
  },
  {
    path: 'setup/success',
    component: DeviceSetupSuccessComponent,
    data: {
      title: 'Device Setup Success',
    },
    canActivate: [HasSmartDevicesWritePermissionGuard],
  },
  {
    path: 'setup/thermostat-success',
    component: ThermostatSetupSuccessComponent,
    data: {
      title: 'Thermostat Setup Success',
    },
    canActivate: [HasSmartDevicesWritePermissionGuard],
    children: [
      {
        path: '',
        component: ThermostatSetupSuccessPresetsComponent,
      },
      {
        path: 'occupied',
        component: ThermostatSetupSuccessOccupiedComponent,
      },
      {
        path: 'unoccupied',
        component: ThermostatSetupSuccessUnoccupiedComponent,
      },
      {
        path: 'long-term-unoccupied',
        component: ThermostatSetupSuccessLongTermComponent,
      },
      {
        path: 'done',
        component: ThermostatSetupSuccessDoneComponent,
      },
    ],
  },
  {
    path: 'thermostat-presets',
    component: DeviceThermostatPresetsComponent,
    data: {
      title: 'Thermostat Presets',
    },
  },
  {
    path: 'thermostat-presets/:id',
    component: DeviceThermostatPresetDetailComponent,
    data: {
      title: 'Thermostat Presets Detail',
    },
  },
  {
    path: 'settings',
    component: DeviceSettingsComponent,
    data: {
      title: 'Device Settings',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SmartDevicesRoutingModule {}
